import { render } from "./EventFields.vue?vue&type=template&id=05adddaa"
import script from "./EventFields.vue?vue&type=script&lang=js"
export * from "./EventFields.vue?vue&type=script&lang=js"

import "./EventFields.vue?vue&type=style&index=0&id=05adddaa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__